export const doughnutChartColors = ['#8ABFFF', '#DDDDDD', '#FF8B7C', '#006EF0', '#178B17', '#535353', '#DF0017']
